import { cfpBaseUrl } from "../network/urls";
import { groupComplaintHistoryApiRows } from "./complaintHistory";

const HISTORY_API = `${cfpBaseUrl}lineComplaints/getComplaintsWithHistByTicketNo`;
const SEARCH_API = `${cfpBaseUrl}lineComplaints/complaintsSearchBar`;

function buildHistoryRequestBody(searchType, searchValue) {
  const trimmed = String(searchValue || "").trim();

  if (searchType === "referenceNo") {
    return {
      RefNo: trimmed,
      ReferenceNo: trimmed,
      TicketNoOrEOpsTrackingId: trimmed,
    };
  }

  return {
    TicketNoOrEOpsTrackingId: trimmed,
  };
}

async function postJson(url, token, body) {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
    redirect: "follow",
  });

  return response.json();
}

function normalizeComplaintList(result) {
  if (result?.status === "200" && Array.isArray(result.data)) {
    return groupComplaintHistoryApiRows(result.data);
  }
  return [];
}

async function searchByReferenceFallback(token, referenceNo) {
  const result = await postJson(SEARCH_API, token, {
    searchParameter: referenceNo,
  });

  const items = Array.isArray(result?.Data) ? result.Data : [];
  const ref = String(referenceNo).trim();

  return items.filter((item) => {
    const itemRef = String(
      item.RefNo || item.refNo || item.referenceNo || item.ReferenceNo || "",
    ).trim();
    return itemRef === ref || itemRef.includes(ref) || ref.includes(itemRef);
  });
}

export async function fetchComplaintsWithHistory(token, searchType, searchValue) {
  const trimmed = String(searchValue || "").trim();
  if (!trimmed) {
    return { complaints: [], message: "Enter a search value." };
  }

  let complaints = normalizeComplaintList(
    await postJson(HISTORY_API, token, buildHistoryRequestBody(searchType, trimmed)),
  );

  if (complaints.length === 0 && searchType === "referenceNo") {
    const matched = await searchByReferenceFallback(token, trimmed);
    const trackingIds = [
      ...new Set(
        matched
          .map(
            (item) =>
              item.EOpsTrackingId ||
              item.eOpsTrackingId ||
              item.complaintId ||
              item.TicketNo,
          )
          .filter(Boolean),
      ),
    ];

    const fetched = await Promise.all(
      trackingIds.map(async (trackingId) => {
        const result = await postJson(HISTORY_API, token, {
          TicketNoOrEOpsTrackingId: trackingId,
        });
        return normalizeComplaintList(result);
      }),
    );

    complaints = fetched.flat();

    const ref = trimmed.toLowerCase();
    complaints = complaints.filter((item) => {
      const itemRef = String(item.RefNo || item.refNo || "").toLowerCase();
      return !itemRef || itemRef.includes(ref) || ref.includes(itemRef);
    });
  }

  if (complaints.length === 0) {
    return {
      complaints: [],
      message:
        searchType === "referenceNo"
          ? "No complaint found for this Reference Number."
          : "No complaint found for this Complaint ID.",
    };
  }

  return { complaints, message: "" };
}
